import { pagesConfig } from '../../../shared/pages-config';
import BulkOpsGrid from './bulk-ops-grid';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import { Outlet } from 'react-router-dom';

export default function BulkOpsPage() {
  const { toolsRoles, loggedInUser } = useUserSettings();
  const isFormPage = useRouteMatch([
    `${pagesConfig.bulkOps.link}/${pagesConfig.createBulkOps.link}`,
  ]);

  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.importExport.name },
        { label: pagesConfig.bulkOps.name },
      ]}
      bookmarkKey={pagesConfig.bulkOps.value}
    >
      <BulkOpsGrid loggedInUserEmail={loggedInUser} toolsRoles={toolsRoles} />
    </SimpleBreadcrumbsPage>
  );
}
